/*
  TGC — sticky buy bar wiring.

  The bar owns no form state of its own. It writes its quantity into Dawn's real
  quantity input and clicks Dawn's real submit button, both of which stay inside
  <product-form> where product-form.js expects to find them (it resolves the
  submit button via this.querySelector('[type="submit"]') and would throw if the
  button were moved out).

  It also mirrors the real button's label and disabled state, so sold-out and
  variant changes stay in sync without duplicating any of that logic.
*/
(function () {
  'use strict';

  function wire(bar) {
    var sectionId = bar.dataset.sectionId;
    var realButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var realQty = document.getElementById('Quantity-' + sectionId);

    var cta = bar.querySelector('[data-tgc-add]');
    var input = bar.querySelector('[data-tgc-qty-input]');
    var steppers = bar.querySelectorAll('[data-tgc-qty]');

    if (!cta || !input) return;

    // Without a real button there is nothing to proxy to — leave the bar inert
    // rather than showing a button that silently does nothing.
    if (!realButton) {
      bar.hidden = true;
      return;
    }

    function clampQty(value) {
      var min = parseInt(input.min, 10) || 1;
      var n = parseInt(value, 10);
      if (isNaN(n) || n < min) n = min;
      return n;
    }

    function syncSteppers() {
      var min = parseInt(input.min, 10) || 1;
      steppers.forEach(function (button) {
        if (parseInt(button.dataset.tgcQty, 10) < 0) {
          button.disabled = clampQty(input.value) <= min;
        }
      });
    }

    steppers.forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = clampQty(clampQty(input.value) + parseInt(button.dataset.tgcQty, 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    input.addEventListener('change', function () {
      input.value = clampQty(input.value);
      syncSteppers();
    });

    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      if (realQty) {
        realQty.value = clampQty(input.value);
        realQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      realButton.click();
    });

    // Mirror label + disabled state; Dawn rewrites both on variant change.
    function mirror() {
      var label = realButton.querySelector('span');
      if (label) cta.textContent = label.textContent.trim();
      var off = realButton.disabled || realButton.getAttribute('aria-disabled') === 'true';
      cta.disabled = off;
      cta.classList.toggle('is-loading', realButton.classList.contains('loading'));
    }

    mirror();
    new MutationObserver(mirror).observe(realButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    syncSteppers();
  }

  function init() {
    document.querySelectorAll('[data-tgc-buybar]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
